import React from 'react';
import { slugify } from './utils/productCategoryHelpers';

function BooleanToggle({ id, label, checked, onChange, disabled }) {
  return (
    <div className="mb-3">
      <label className="form-label d-block">{label}</label>
      <div className="status-toggle modal-status">
        <input
          type="checkbox"
          id={id}
          className="check"
          checked={!!checked}
          disabled={disabled}
          onChange={(e) => onChange(e.target.checked)}
        />
        <label htmlFor={id} className="checktoggle" />
      </div>
    </div>
  );
}

function ProductCategoryDetailsFields({
  formData,
  sendDataToParent,
  readOnly = false,
  slugManual = false,
  onSlugManualChange,
}) {
  const propagate = (next) => {
    if (sendDataToParent) sendDataToParent(next);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const next = { ...formData, [name]: value };
    if (name === 'CategoryName' && !slugManual) {
      next.Slug = slugify(value);
    }
    propagate(next);
  };

  const handleToggle = (name, checked) => {
    propagate({ ...formData, [name]: checked });
  };

  if (readOnly) {
    return (
      <div className="row">
        <div className="col-lg-6 mb-2"><strong>Category Name:</strong> {formData.CategoryName || '-'}</div>
        <div className="col-lg-6 mb-2"><strong>Slug:</strong> {formData.Slug || '-'}</div>
        <div className="col-lg-12 mb-2"><strong>Image URL:</strong> {formData.ImageUrl || '-'}</div>
        <div className="col-lg-6 mb-2"><strong>Display Order:</strong> {formData.DisplayOrder ?? 0}</div>
        <div className="col-lg-6 mb-2"><strong>Active:</strong> {formData.IsActive ? 'Yes' : 'No'}</div>
      </div>
    );
  }

  return (
    <div className="row">
      <div className="col-lg-6">
        <div className="mb-3">
          <label className="form-label">
            Category Name<span style={{ color: 'red' }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="CategoryName"
            value={formData.CategoryName || ''}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="col-lg-6">
        <div className="mb-3">
          <label className="form-label">
            Slug<span style={{ color: 'red' }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="Slug"
            value={formData.Slug || ''}
            onChange={(e) => {
              if (onSlugManualChange) onSlugManualChange(true);
              handleChange(e);
            }}
          />
        </div>
      </div>
      <div className="col-lg-12">
        <div className="mb-3">
          <label className="form-label">Image URL</label>
          <input
            type="text"
            className="form-control"
            name="ImageUrl"
            placeholder="/uploads/category-image.jpg"
            value={formData.ImageUrl || ''}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="col-lg-6">
        <div className="mb-3">
          <label className="form-label">Display Order</label>
          <input
            type="number"
            className="form-control"
            name="DisplayOrder"
            value={formData.DisplayOrder ?? 0}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="col-lg-6">
        <BooleanToggle
          id={`IsActive-${formData.CategoryId || 'new'}`}
          label="Active"
          checked={formData.IsActive}
          onChange={(v) => handleToggle('IsActive', v)}
        />
      </div>
    </div>
  );
}

export default ProductCategoryDetailsFields;
